import axios from "axios";
import { getBackendUrl } from "./backend.url";

export const getPolls = () => {
  return axios.get(`${getBackendUrl()}/poll`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const addPoll = (poll) => {
  return axios.put(`${getBackendUrl()}/poll`, poll, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const removePoll = (pollId) => {
  return axios.delete(`${getBackendUrl()}/poll/${pollId}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const votePoll = (pollId, optionIndex) => {
  return axios.post(
    `${getBackendUrl()}/poll/${pollId}/${optionIndex}`,
    {},
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};

export const closePoll = (pollId) => {
  return axios.post(
    `${getBackendUrl()}/poll/${pollId}/close`,
    {},
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};
